import '../styles/banner.scss'

export const Banner = () =>
{
    return <div className='banner'>
        <h1 className='banner__header'>Hi, I'm Tom.</h1>
        <p className='banner__text'>A product development specialist, versed in frontend and backend engineering with C#, JavaScript, and Swift.</p>
    </div>
}